import { render, staticRenderFns } from "./ConsultationListComponent.vue?vue&type=template&id=f2e837bc&scoped=true"
import script from "./ConsultationListComponent.vue?vue&type=script&lang=ts"
export * from "./ConsultationListComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e837bc",
  null
  
)

export default component.exports